import { REFERENCES_DOMAIN } from '../../constants'
import { createSelector } from 'reselect'

function getReferencesSelector (path) {
  return createSelector(state => state[REFERENCES_DOMAIN],
    domain => domain[path] || []
  )
}

export default getReferencesSelector
